// extracted by mini-css-extract-plugin
export default {"social-link":"SocialLinks_social-link__xLxR8","social-link__icon":"SocialLinks_social-link__icon__S6-OR"};